import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import Footer from "../components/Footer/Footer";
import "./assets/styles.css";
import "../assets/styles.css";

const Admin = ({ children }) => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="d-flex flex-grow-1 w-100">
        <div
          className="bg-light p-3 d-none d-md-block border-end h-100"
          style={{ width: "250px", flexShrink: 0, overflowY: "auto" }}
        >
          <Sidebar />
        </div>
        <main className="flex-grow-1 p-2 p-md-3">
          <Header />
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-12 col-md-11 col-lg-10 mb-4 mt-4">
                {children}
              </div>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Admin;
